import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import DataTable from 'src/Components/DataTable';
import EInputMask from 'src/Components/EInput/EInputMask';
import { IContact } from 'src/Interfaces/WellInterface';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import CopyWellSelectTable from '../CopyWellSelectTable/CopyWellSelectTable';

const mask = new EInputMask();
@inject('stores')
@observer
class WellContactsCopyModal extends React.Component {

    public props: any;

    private WellsStore: WellsStore;

    public state = {
        selectedContacts: {
            contractorContacts: [],
            operatorContacts: [],
            otherContacts: [],
        }
    };
    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
    }

    public formatContacts = (field: string) => {
        const headers = [
            {
                content: '',
                width: 1,
            },
            'Contact Name',
            'Phone Number',
            'Email',
        ];

        const { well, copyWell } = this.WellsStore;

        if (!copyWell) {
            return { headers, rows: []};
        }

        const rows = copyWell[field]
            .filter((value: IContact) => !well[field].some((cont: IContact) => 
            cont.firstName === value.firstName && cont.lastName === value.lastName && cont.email === value.email))
            .map((value: IContact, index:number) => [
            {
                content: this.renderContactCheckBox(field, index),
                type: 'render',
            },
            {
                content: `${value.firstName} ${value.lastName}`,
            },
            {
                content: mask.phone(value.phoneMobile)
            },
            {
                content: value.email,
            }
        ]);

        return { headers, rows };
    }

    public handleContactSelect = (field: string, index: number) => (event: any) => {
        const selectedContacts = this.state.selectedContacts;
        selectedContacts[field][index] = !selectedContacts[field][index];
        this.setState({selectedContacts});
    }

    public renderContactCheckBox = (field: string, index: number) => () => {
        const checked = this.state.selectedContacts[field];
        return (
            <div className="multi-select-row">
                <Input
                    type="checkbox"
                    checked={!checked[index]}
                    onChange={this.handleContactSelect(field, index)}
                />
            </div>
        );
    }

    @action
    public saveContacts = () => {
        const { well, copyWell } = this.WellsStore;
        const selectedContacts = this.state.selectedContacts;
        const operatorSelections = selectedContacts.operatorContacts;
        const contractorSelections = selectedContacts.contractorContacts;
        const otherSelections = selectedContacts.otherContacts;
        copyWell.operatorContacts.filter((value: IContact) => !well.operatorContacts.some((cont: IContact) => 
        cont.firstName === value.firstName && cont.lastName === value.lastName && cont.email === value.email))
        .forEach((value, index) => {
            if (!operatorSelections[index]) {
                const tempValue: IContact = DeepCopy(value);
                tempValue.id = '';
                well.operatorContacts.push(tempValue);
            }
        });

        copyWell.contractorContacts.filter((value: IContact) => !well.contractorContacts.some((cont: IContact) => 
        cont.firstName === value.firstName && cont.lastName === value.lastName && cont.email === value.email))
        .forEach((value, index) => {
            if (!contractorSelections[index]) {
                const tempValue: IContact = DeepCopy(value);
                tempValue.id = '';
                well.contractorContacts.push(tempValue);
            }
        });

        copyWell.otherContacts.filter((value: IContact) => !well.otherContacts.some((cont: IContact) => 
        cont.firstName === value.firstName && cont.lastName === value.lastName && cont.email === value.email))
        .forEach((value, index) => {
            if (!otherSelections[index]) {
                const tempValue: IContact = DeepCopy(value);
                tempValue.id = '';
                well.otherContacts.push(tempValue);
            }
        });
        this.WellsStore.updateWellModel(well);
        this.toggleModal();
    }

    public toggleModal = () => {
        this.setState({
            selectedContacts: {
                contractorContacts: [],
                operatorContacts: [],
                otherContacts: [],
            }
        });
        this.props.toggle();
    }

    public clearSelections = () => {
        this.setState({
            selectedContacts: {
                contractorContacts: [],
                operatorContacts: [],
                otherContacts: [],
            }
        });
    }

    public render() {
        const open = this.props.open;
        const toggle = this.toggleModal;
        const copyWell = this.WellsStore.copyWell;
        if (open) {
            return (
                <Modal size="lg" isOpen={open} toggle={toggle} backdrop="static">
                    <ModalHeader toggle={toggle}>
                        Copy Contacts
                    </ModalHeader>
                    <ModalBody>
                        <CopyWellSelectTable onClear={this.clearSelections} />
                        {
                            copyWell &&
                            <React.Fragment>
                                <h6>Operator Contacts</h6>
                                <DataTable
                                    list={this.formatContacts('operatorContacts')}
                                />
                                <h6>Contractor Contacts</h6>
                                <DataTable
                                    list={this.formatContacts('contractorContacts')}
                                />
                                <h6>Other Contacts</h6>
                                <DataTable
                                    list={this.formatContacts('otherContacts')}
                                />
                            </React.Fragment>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={toggle}>Cancel</Button>
                        <Button color="primary" disabled={copyWell === undefined} onClick={this.saveContacts}>Save Contacts</Button>
                    </ModalFooter>
                </Modal>
            );
        }
        return '';
    }
}

export default WellContactsCopyModal;


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellContacts/WellContactsCopyModal.tsx